/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_End_TitleInputs */



/**
* | output |
* | --- |
* | "Chain to Next Event" |
*
* @param {Snap_To_End_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_end_title = /** @type {((inputs?: Snap_To_End_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_End_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enchainer a l'Evenement Suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung zum nächsten Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Catena al prossimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цепочка к следующему событию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cadena al siguiente evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("链至下一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントへのチェーン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगले इवेंट से जुड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Encadeamento para o próximo evento")
	return /** @type {LocalizedString} */ ("Chain to Next Event")
});